<script lang="ts" setup>
import type { PromoCta } from '#core/types'

const items = [
  'Use one of our recommended templates, or start from scratch',
  'Model your distribution, emissions, and demand drivers',
  'Review the estimated valuation',
  'Stress-test your model for 6 different parameters',
  'Publish a one-pager to share with VCs and market makers',
]

const ctas: PromoCta[] = [
  { label: 'Start for Free', to: '/design-tokenomics' },
  { label: 'Watch the 2-Minute Demo', variant: 'outline', icon: 'play', videoUrl: 'https://www.youtube.com/watch?v=yR-PL0_7Q44' },
]
</script>

<template>
  <CorePromoBanner
    heading="TGE-proof your tokenomics strategy"
    intro="Start our simple guided process:"
    ordered
    :items="items"
    :ctas="ctas"
    image="/images/home/promo-tokenomics.webp"
  />
</template>
